import React from 'react'

type RefreshCheckBoxProps = {
  checked: boolean
  onToggle: (enabled: boolean) => void
  title: string
}

export function RefreshCheckBox({ checked, onToggle, title = 'Toggle auto refresh' }: RefreshCheckBoxProps) {
  return (
    <label className="refresh-checkbox" title={title}>
      <input type="checkbox" checked={checked} onChange={(e) => onToggle(e.target.checked)} />
      <span className="pl-1">Auto refresh</span>
    </label>
  )
}
